// src/components/lead/sections/TrainingRoleplayPanel.tsx — KB-grounded AI customer roleplay + session scoring.
import type { Location } from "@/types/location";
import { TrainingRoleplayPanelView } from "@/components/lead/sections/TrainingRoleplayPanelView";
import { useTrainingRoleplayPanel } from "@/components/lead/sections/useTrainingRoleplayPanel";

type TrainingRoleplayPanelProps = {
  organizationId: string | null;
  location: Location | null;
};

export function TrainingRoleplayPanel(props: TrainingRoleplayPanelProps) {
  const { organizationId, location } = props;
  const vm = useTrainingRoleplayPanel(organizationId, location);
  return <TrainingRoleplayPanelView vm={vm} />;
}
